/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-10T17:00:05.81
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialSettlementItem,
	listFinancialSettlementItemInit,
	listFinancialSettlementItemByAuthorizations,
	deleteFinancialSettlementItem
} from '@api/financial/FinancialSettlementItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialSettlementItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialSettlementItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialSettlementItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialSettlementItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialSettlementItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialSettlementItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialSettlementItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialSettlementItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
